import { useFadeIn } from '@/hooks/useFadeIn';
import { Link } from 'react-router-dom';
import { allBlogPosts, type BlogPost } from '@/mocks/blogData';

function BlogCard({ post, index }: { post: BlogPost; index: number }) {
  const { ref, isVisible } = useFadeIn(0.1);
  const isDraPost = post.id === 3;
  const isCirurgiaPost = post.id === 6;
  return (
    <Link
      ref={ref}
      to={`/blog/${post.slug}`}
      className={`group bg-background-50 rounded-xl overflow-hidden card-hover fade-section ${isVisible ? 'is-visible' : ''}`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="relative overflow-hidden h-52 img-zoom">
        <img
          src={post.image}
          alt={post.title}
          className={`w-full h-full object-cover ${
            isDraPost ? 'object-[50%_20%]' : isCirurgiaPost ? 'object-[50%_10%]' : 'object-center'
          }`}
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2.5 py-1 rounded-full">
            {post.category}
          </span>
          <span className="text-xs text-foreground-400">{post.readTime}</span>
        </div>
        <h4 className="font-heading text-base font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors duration-300">
          {post.title}
        </h4>
        <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-4">
          {post.excerpt}
        </p>
        <span className="text-xs text-foreground-400">{post.date}</span>
      </div>
    </Link>
  );
}

export default function BlogSection() {
  const { ref: headerRef, isVisible: headerVisible } = useFadeIn(0.15);

  return (
    <section id="blog" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={headerRef}
          className={`flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 fade-section ${headerVisible ? 'is-visible' : ''}`}
        >
          <div>
            <span className="text-xs uppercase tracking-[0.2em] text-secondary-600 font-semibold mb-3 block">
              Blog
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Conteúdos sobre
              <br />
              <span className="italic font-normal text-foreground-500">saúde e estética bucal</span>
            </h2>
          </div>
          <Link
            to="/blog-faria-lima"
            className="whitespace-nowrap text-sm font-semibold text-primary-500 flex items-center gap-2 hover:text-primary-600 transition-colors cursor-pointer"
          >
            Artigos exclusivos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {allBlogPosts.map((post, index) => (
            <BlogCard key={post.id} post={post} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}